<template>
    <div class="rows">
        <div style="margin-bottom: 10px;">
            <table class="table-border-none">
                <tr>
                    <td style="padding-left: 0;">Příjmení:</td>
                    <td><input v-model="item.prijmeni" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Jméno:</td>
                    <td><input v-model="item.jmeno" style="width: 400px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">E-mail:</td>
                    <td><input v-model="item.email" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Role:</td>
                    <td>
                        <select v-model="item.idRole" style="width: 150px;">
                            <option :value="1">Uživatel</option>
                            <option :value="2">Editor</option>
                            <option :value="3">Manažer</option>
                            <option :value="6">Projektant</option>
                            <option :value="4">Investor</option>
                            <option :value="5">Administrátor</option>
                        </select>
                        <span class="required">*</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="cols" style="gap: 10px;">
            <button @click="saveItem">Uložit</button>
            <button @click="close">Zavřít</button>
            <button v-if="itemId !== -1" @click="deleteItem">Smazat</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'

    export default {
        name: 'EditUzivatel',
        props: ['itemId'],
        data() {
            return {
                item: {
                    'id': -1,
                    'email': '',
                    'prijmeni': '',
                    'jmeno': '',
                    'idRole': 1,
                    'role': ''
                }
            }
        },
        methods: {
            load() {
                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'email': '',
                        'prijmeni': '',
                        'jmeno': '',
                        'idRole': 1,
                        'role': ''
                    }
                }
                else {
                    this.$progress.start()
                    api.getUzivatelById(this.itemId)
                    .then(response => {
                        this.$progress.finish()
                        this.item = response.data
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                    })
                }
            },
            close() {
                this.$emit('close')
            },
            saveItem() {
                if (confirm('Uložit záznam?')) {
                    if (this.item.prijmeni.length === 0 || this.item.email.length === 0 || this.item.idRole === -1) {
                        alert('Záznam nebude uložen. Povinná pole jsou: Příjmení, E-mail, Role')
                        return
                    }
                    else {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postUzivatel(this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                                this.$emit('close')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putUzivatel(this.item.id, this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                    }
                }
            },
            deleteItem() {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat tento záznam?')) {
                    this.$progress.start()
                    api.deleteUzivatel(this.item.id)
                    .then(() => {
                        this.$progress.finish()
                        this.$emit('updateTable')
                        this.$emit('close')
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                        alert('Nastala chyba při mazání. Záznam nebyl smazán.')
                    })
                }
            }
        },
        created() {
            this.load()
        },
        beforeUpdate() {
            if (this.itemId !== this.item.id) {
                this.load()
            }
        }
    }
</script>